import { useAppDispatch } from '@core/redux/hooks';
import {
  decreaseLoading,
  increaseLoading,
} from '@features/layout/store/layout.slice';
import { Modal } from '@models';
import { modals } from '@service/api';
import { TakeSkipFilter } from '@typings';
import { useState } from 'react';

import OpenNotification from '../components/antd/OpenNotification';

export const useModalOrdering = () => {
  const dispatch = useAppDispatch();

  const [modalOrderingList, setModalOrderingList] =
    useState<Modal.ResponseOrdering>({});

  const [orderignModal, setOrderingModal] = useState<Modal.OrderingModal[]>([]);

  const getOrderingModals = async (props?: TakeSkipFilter) => {
    try {
      dispatch(increaseLoading());

      const response = await modals.getOrderingModals({
        filter: { ...props?.filter },
      });
      setModalOrderingList(response);
    } catch (err) {
      console.log(err);
      OpenNotification(true, 'Falha ao carregar os programas do sistema.');
    } finally {
      dispatch(decreaseLoading());
    }
  };

  const saveSort = async (props: Modal.OrderingModal[]) => {
    try {
      dispatch(increaseLoading());

      await modals.saveOrder(
        props.map((modal, index) => ({
          modalId: modal.modalId,
          order: index,
          segmentId: modal.segmentId,
        }))
      );
      setOrderingModal([]);
      OpenNotification(false, 'Modais ordenados com sucesso!');
    } catch (err) {
      console.log(err);
      OpenNotification(true, 'Falha ao carregar os programas do sistema.');
    } finally {
      dispatch(decreaseLoading());
    }
  };

  return {
    saveSort,
    getOrderingModals,
    modalOrderingList,
    orderignModal,
    setOrderingModal,
  };
};
